module.exports = __webpack_public_path__ + "img/share_care_fx.67ba38bf.png";